import React from 'react'

import { CarouselControlDirection } from '@adUtilities/constants/carousel'

export const setScrollPosition: (
  dotContainerRef: React.RefObject<HTMLDivElement>,
  direction?: CarouselControlDirection
) => void = (
  dotContainerRef,
  direction = CarouselControlDirection.Horizontal
) => {
  const containerElem = dotContainerRef.current as HTMLElement | undefined
  const collection = document.getElementsByClassName(
    'carousel-control-active-item'
  )
  const activeElement = collection[0] as HTMLElement | undefined
  if (containerElem && activeElement) {
    if (direction === CarouselControlDirection.Horizontal) {
      containerElem.scrollTo({
        left: activeElement.offsetLeft,
        behavior: 'smooth',
      })
    }
    if (direction === CarouselControlDirection.Vertical) {
      containerElem.scrollTo({
        top: activeElement.offsetTop,
        behavior: 'smooth',
      })
    }
  }
}

export default {}
